import WrapperComponent from '../components/hoc/Wrapper-component';
import { Register } from './registration/Register';
import { HomeScene } from './home/HomeScene';
import { LoginDealer } from './login-dealer/LoginDealer';
import { ClaimScene } from './claims/ClaimScene';
import { ProfileScene } from './profile/ProfileScene';
import { ProfileStore } from './profile-store/ProfileStore';
export default {
  Register: WrapperComponent('Register')(Register),
  HomeScene: WrapperComponent('HomeScene')(HomeScene),
  LoginDealer: WrapperComponent('LoginDealer')(LoginDealer),
  ClaimScene: WrapperComponent('ClaimScene')(ClaimScene),
  ProfileScene: WrapperComponent('ProfileScene')(ProfileScene),
  ProfileStore: WrapperComponent('ProfileStore')(ProfileStore),
};
